<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import PubSub from "pubsub-js";
    export default {
        name: "OperationLog",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                    {
                        name: 'userId',
                        placeholder: '管理员',
                        type: 'select',
                        selectUrl:'/adminInfo/all',
                        selectValue:[]
                    },
                    {
                        name: 'type',
                        placeholder: '类型',
                        type: 'select',
                        selectUrl:'',
                        selectValue:[{
                            key: 0,
                            value: '添加'
                        },{
                            key: 1,
                            value: '删除'
                        },{
                            key: 2,
                            value: '批量删除'
                        },{
                            key: 3,
                            value: '更新'
                        },{
                            key: 4,
                            value: '导出'
                        },{
                            key: 5,
                            value: '上传'
                        },{
                            key: 6,
                            value: '确认'
                        },{
                            key: 7,
                            value: '登录'
                        }]
                    },
                    {
                        name: 'url',
                        placeholder: '请求地址',
                        type: 'input'
                    },
                    {
                        name: 'args',
                        placeholder: '请求参数',
                        type: 'input'
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'operationLog:add',
                    update: 'operationLog:update',
                    delete: 'operationLog:delete',
                    deleteBatch: 'operationLog:deleteBatch'
                },
                url: {
                    get: '/operationLog/listByCondition',
                    //add: '/operationLog/add',
                    //update: '/operationLog/update',
                    //delete: '/operationLog/delete/',
                    //delete_batch: '/operationLog/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '100',
                },{
                    field: 'userId',
                    label: '管理员',
                    selectUrl: '/adminInfo/all',
                    selectData: [],
                    show: {
                        type:'select'
                    },
                    width: '',
                }, {
                    field: 'type',
                    label: '类型',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 0,
                            value: '添加',
                            type: 'warning'
                        },{
                            key: 1,
                            value: '删除',
                            type: 'danger'
                        },{
                            key: 2,
                            value: '批量删除',
                            type: 'danger'
                        },{
                            key: 3,
                            value: '更新',
                            type: 'warning'
                        },{
                            key: 4,
                            value: '导出',
                            type: 'info'
                        },{
                            key: 5,
                            value: '上传',
                            type: 'info'
                        },{
                            key: 6,
                            value: '确认',
                            type: 'warning'
                        },{
                            key: 7,
                            value: '登录',
                            type: 'success'
                        }]
                    },
                    width: '',
                }, {
                    field: 'name',
                    label: '名称',
                    show: true,
                    width: '',
                }, {
                    field: 'url',
                    label: '地址',
                    show: true,
                    width: '',
                }, {
                    field: 'args',
                    label: '请求参数',
                    show: true,
                    width: '',
                }, {
                    field: 'ip',
                    label: '请求IP',
                    show: true,
                    width: '',
                }, {
                    field: 'createTime',
                    label: '请求时间',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '添加',
                    updateTitle: '修改',
                    model: []
                }
            }
        },
        mounted() {
            PubSub.subscribe("refreshOperationLog",() => {
                this.$refs.table.getData();
            });
        }
    }
</script>

<style scoped>

</style>
